<template>
  <div class="content_list">
    <div
      class="list_item"
      v-for="(item, index) in companyLists"
      :key="index"
      @click="item_click(item)"
    >
      <div class="image_box">
        <el-image
          class="item_img"
          :src="
            item.cover ||
            'https://oss.chinadentalshow.com/resource/image/pc/559dda45658260b6e9a1e1d800ae02ed.png'
          "
          fit="contain"
        ></el-image>
      </div>
      <div class="m_div">
        <div class="item_text1 margin_bottom">
          {{ langSet == "cn" ? item.title : item.en_title }}
        </div>
        <div class="item_text2 margin_bottom">
          {{ (langSet == "cn" ? "展位号：" : "Booth No：") + item.booth_no }}
        </div>
        <div class="item_text3 margin_bottom">
          {{
            langSet == "cn"
              ? "展商类别：" +
                (item.enterprise_type ? item.enterprise_type : "")
              : "Exhibitor Category：" +
                (item.enterprise_type_en ? item.enterprise_type_en : "")
          }}
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "company_list",
  components: {},
  props: ["companyLists", "external"],
  data() {
    return {
      langSet: "cn",
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    async item_click(item) {
      if (this.external) {
        this.$emit("item_click", item, this.external);
      } else {
        this.$emit("item_click", item);
      }
    },
  },
};
</script>


<style scoped lang="scss">
.content_list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}
.list_item {
  padding: 15px;
  //width: 305px;
  height: 317px;
  background: #f7f8fa;
  box-sizing: border-box;
  text-align: center;
  flex: 0 0 calc(25% - 20px);
  margin: 10px;
  overflow: hidden;
  cursor: pointer;
  &:hover {
    border: 1px solid #004190;
  }
}

.image_box {
  //width: 275px;
  height: 155px;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
  padding: 0 17px;
}

.item_img {
  //height: auto;
  //object-fit: cover;
  width: 240px !important;
  height: 135px !important;
}
.margin_bottom {
  width: 100%;
  margin-bottom: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item_text1 {
  font-weight: 600;
  font-size: 20px;
  color: #2c2c2e;
  line-height: 28px;
  text-align: left;
  font-style: normal;
}

.item_text2 {
  font-weight: 400;
  font-size: 18px;
  color: #757575;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}

.item_text3 {
  font-weight: 400;
  font-size: 18px;
  color: #757575;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}
@media only screen and (max-width: 767px) {
  .content_list {
    margin: 0;
    .list_item {
      width: 100%;
      height: auto;
      flex: inherit;
      display: flex;
      padding: 0.29rem;
      margin: 0 0 0.29rem;
      .image_box {
        width: 2.4rem;
        height: 1.35rem;
        padding: 0;
        margin-bottom: 0;
        margin-right: 0.19rem;
        .item_img {
          width: 2.4rem !important;
          height: 1.35rem !important;
        }
      }
      .m_div {
        flex: 1;
        .item_text1 {
          font-size: 0.29rem;
          line-height: 0.4rem;
        }
        .item_text2,
        .item_text3 {
          color: #757575;
          font-size: 0.25rem;
          line-height: 0.35rem;
        }
        .margin_bottom {
          width: 84%;
          margin-bottom: 0.1rem;
        }
        .item_text3 {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>